import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'

interface HelpIconTooltipProps {
  message: string
}

export const HelpIconTooltip: React.FC<HelpIconTooltipProps> = ({
  message
}) => {
  return (
    <Tooltip title={message}>
      <IconButton aria-label='help'>
        <HelpOutlineIcon />
      </IconButton>
    </Tooltip>
  )
}
